import { FC } from 'react';
import { DiscoverSkeletonInfo } from '~/skeleton/discover/component';
import { SkeletonScanline } from '~/skeleton/common/skeleton-scanline';
import { SkeletonWrapper } from '~/skeleton/common/skeleton-wrapper';
import {
  ArticleAuthorSkeleton,
  ArticleContentSkeleton,
  ArticleLargeImageSkeleton,
  ArticleTitleSkeleton,
} from '~/skeleton/article/component';

export const DiscoverFullSkeleton: FC = () => {
  return (
    <SkeletonWrapper fix>
      <DiscoverSkeletonInfo />
      <ArticleAuthorSkeleton />
      <ArticleLargeImageSkeleton />
      <ArticleTitleSkeleton />
      <ArticleContentSkeleton />
      <SkeletonScanline />
    </SkeletonWrapper>
  );
};

export const DiscoverBodySkeleton: FC = () => {
  return (
    <SkeletonWrapper>
      <DiscoverSkeletonInfo />
      <ArticleAuthorSkeleton />
      <ArticleLargeImageSkeleton />
      <ArticleTitleSkeleton />
      <ArticleContentSkeleton />
      <SkeletonScanline />
    </SkeletonWrapper>
  );
};
